import React, {
    useCallback, useMemo,
} from 'react'
import {
    GridFilterInputValueProps,
} from '@mui/x-data-grid-pro'

import Checkbox from 'app/shared-components/Checkbox'
import useStyles from './BooleanFilterInput.styles'

const parseFilterValue = (trueValue: boolean, falseValue: boolean) => {
    if (trueValue && falseValue) {
        return [
            true,
            false,
        ]
    }

    if (trueValue) {
        return [true]
    }

    if (falseValue) {
        return [false]
    }

    return null
}

function BooleanFilterInput({
    item,
    applyValue,
}: Readonly<GridFilterInputValueProps>) {
    const {
        classes,
    } = useStyles()

    const trueValue = useMemo(() => {
        return Array.isArray(item.value) && item.value.includes(true)
    }, [item.value])

    const falseValue = useMemo(() => {
        return Array.isArray(item.value) && item.value.includes(false)
    }, [item.value])

    const onChangeTrue = useCallback((value: boolean) => {
        applyValue({
            ...item,
            value: parseFilterValue(value, falseValue),
        })
    }, [
        applyValue,
        item,
        falseValue,
    ])

    const onChangeFalse = useCallback((value: boolean) => {
        applyValue({
            ...item,
            value: parseFilterValue(trueValue, value),
        })
    }, [
        applyValue,
        item,
        trueValue,
    ])

    return (
        <div className={classes.container}>
            <Checkbox
                title="True"
                value={trueValue}
                onChange={onChangeTrue}
                className={classes.checkbox}
            />
            <Checkbox
                title="False"
                value={falseValue}
                onChange={onChangeFalse}
                className={classes.checkbox}
            />
        </div>
    )
}

export default BooleanFilterInput
